import { Button, Modal } from '../../Universal/NovusDSImports';
import { btnStyles } from '../../Universal/NovusDSImports/variants';
import { ExtendDurationModal } from './styles';
const ExtendEventDurationConfirmationModal = (props) => {
  const { extendedDuration, closeModal, submitForm, isExtend } = props;
  return (
    <ExtendDurationModal>
      <h2 data-testid="modal-heading">
        Do you want to {isExtend ? 'extend' : 'reduce'} the event duration?
      </h2>
      <p data-testid="modal-description">
        New event duration: {extendedDuration} hrs
      </p>

      <div className="d-flex gap-3 justify-content-end w-100">
        <Button
          data-testid="modal-cancel-button"
          onClick={closeModal}
          type="button"
          {...btnStyles.secondary}
        >
          Cancel
        </Button>
        <Button
          data-testid="modal-confirm-button"
          {...btnStyles.primary}
          onClick={() => {
            submitForm();
            closeModal();
          }}
        >
          Confirm
        </Button>
      </div>
    </ExtendDurationModal>
  );
};

export default Modal(ExtendEventDurationConfirmationModal);
